var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-1"},[_c('div',{staticClass:"flex items-start"},[(_vm.icon)?_c('div',{staticClass:"text-gray-400 mr-3 w-5 text-center"},[_c('i',{class:`fas ${_vm.icon}`})]):_vm._e(),_c('div',{staticClass:"flex-1"},[_c('div',{staticClass:"text-xs text-gray-500"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"font-semibold mt-1",class:[
          _vm.highlight ? 'text-red-600' : 'text-gray-800',
          { 'text-sm': !_vm.bigText, 'text-base': _vm.bigText },
        ]},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_vm._t("extra")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }